// src/templates/StudentDeveloper.jsx
import React, { useEffect, useState } from "react";
import AOS from "aos";
import { FaGithub, FaLinkedin, FaReact, FaPython, FaJava, FaNodeJs } from "react-icons/fa";
import { SiTailwindcss, SiMongodb, SiFlask } from "react-icons/si";
import { Typewriter } from "react-simple-typewriter";
import { Link } from "react-router-dom"; // Make sure to place this in /src/assets or /public if needed

const StudentDeveloper = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000 });
    import("../data/studentDeveloper.json")
      .then((module) => setData(module.default))
      .catch((err) => console.error("Error loading JSON:", err));
  }, []);

  if (!data) return <div className="text-white text-center mt-10">Loading...</div>;

  const { name, bio, profilePic, github, linkedin, resume, projects, skills, contact, education } = data;


  const skillIcons = {
    React: <FaReact className="text-cyan-400" />,
    Python: <FaPython className="text-yellow-400" />,
    Java: <FaJava className="text-red-500" />,
    NodeJS: <FaNodeJs className="text-green-400" />,
    Tailwind: <SiTailwindcss className="text-blue-400" />,
    MongoDB: <SiMongodb className="text-green-500" />,
    Flask: <SiFlask className="text-white" />,
  };

  return (
    <div className="bg-[#0e0e0e] text-white min-h-screen font-sans">
      <div className="absolute top-6 left-6 z-20 flex items-center gap-3">
        <Link to="/templates" className="flex items-center space-x-3">
        <img src="/logo.png" alt="Project Port Logo" className="h-12 w-12 drop-shadow-lg" />
        <span className="text-xl font-bold text-black">Project Port</span>
        </Link>
      </div>
      {/* Hero */}
      <section className="flex flex-col items-center justify-center py-16 px-4 text-center">
        <img
          src={profilePic}
          alt="Profile"
          className="w-36 h-36 md:w-48 md:h-48 rounded-full shadow-lg shadow-purple-800/50 border-4 border-purple-500 mb-4 hover:scale-105 transition-transform"
          data-aos="fade-down"
        />
        <h1 className="text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent mb-2">
          <Typewriter
            words={[name, "Student Developer", "Future Engineer"]}
            loop={true}
            cursor
            cursorStyle="_"
            typeSpeed={80}
            deleteSpeed={50}
            delaySpeed={1500}
          />
        </h1>
        <p className="text-gray-300 max-w-xl text-sm md:text-base" data-aos="fade-up">{bio}</p>
        <div className="flex flex-wrap justify-center gap-4 mt-6" data-aos="zoom-in">
          <a href={github} target="_blank" rel="noopener noreferrer">
            <FaGithub className="text-2xl hover:text-purple-400 transition" />
          </a>
          <a href={linkedin} target="_blank" rel="noopener noreferrer">
            <FaLinkedin className="text-2xl hover:text-purple-400 transition" />
          </a>
          <a
            href={resume}
            download
            className="bg-purple-600 hover:bg-purple-700 transition px-4 py-2 rounded-lg text-sm font-semibold"
          >
            Download Resume
          </a>
        </div>
      </section>

      {/* Skills */}
      <section className="py-10 px-6 max-w-4xl mx-auto" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-center mb-6 border-b-2 border-purple-500 inline-block pb-2">
          Skills
        </h2>
        <div className="flex flex-wrap justify-center gap-6 mt-4">
          {skills.map((skill, idx) => (
            <div
              key={idx}
              className="flex flex-col items-center bg-[#1e1e1e] p-4 rounded-lg border border-purple-400 w-24 hover:scale-105 transition"
            >
              {skillIcons[skill] || <span className="text-xl">⚙️</span>}
              <span className="text-sm mt-2 text-gray-300">{skill}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Projects */}
      <section className="py-12 px-6 max-w-5xl mx-auto" data-aos="fade-up">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 border-b-2 border-purple-500 inline-block pb-2">
          Projects
        </h2>
        <div className="grid md:grid-cols-2 gap-8">
          {projects.map((proj, i) => (
            <div
              key={i}
              className="bg-[#1e1e1e] border border-purple-500 rounded-xl p-6 shadow-lg hover:shadow-purple-600/30 transition duration-300 transform hover:-translate-y-1"
              data-aos="fade-up"
            >
              <h3 className="text-2xl font-semibold text-purple-300 mb-2">{proj.name}</h3>
              <p className="text-gray-400 text-sm mb-4">{proj.desc}</p>
              <a
                href={proj.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-purple-400 hover:underline"
              >
                View Project →
              </a>
            </div>
          ))}
        </div>
      </section>
      {/* Education */}
<section className="py-14 px-6 max-w-4xl mx-auto text-center" data-aos="fade-up">
  <h2 className="text-3xl md:text-4xl font-bold mb-6 border-b-2 border-purple-500 inline-block pb-2">
    Education
  </h2>
  <div className="grid gap-6 md:grid-cols-2">
    {data.education.map((edu, idx) => (
      <div
        key={idx}
        className="bg-[#1e1e1e] p-5 rounded-lg border-l-4 border-purple-500 text-left shadow-md"
      >
        <h3 className="text-xl font-semibold text-white">{edu.degree}</h3>
        <p className="text-gray-300">{edu.institution}</p>
        <p className="text-sm text-purple-400">{edu.year}</p>
      </div>
    ))}
  </div>
</section>

      {/* Contact */}
<section className="py-14 px-6 max-w-3xl mx-auto text-center" data-aos="fade-up">
  <h2 className="text-3xl md:text-4xl font-bold mb-6 border-b-2 border-purple-500 inline-block pb-2">
    Contact Me
  </h2>
  <p className="text-gray-300 mb-6 text-sm md:text-base">
    I'd love to hear from you! Whether you want to collaborate, have a question, or just want to say hi — feel free to reach out.
  </p>
  <div className="flex flex-col gap-4 items-center justify-center text-sm text-gray-400">
    <div className="hover:text-purple-400 transition">
      📧 <a href={`mailto:${contact.email}`}>{contact.email}</a>
    </div>
    <div className="hover:text-purple-400 transition">
      📱 <span>{contact.phone}</span>
    </div>
    <div className="hover:text-purple-400 transition">
      📍 <span>{contact.location}</span>
    </div>
  </div>
</section>


      {/* Footer */}
      <footer className="text-center py-6 text-gray-500 text-xs">
        © {new Date().getFullYear()} {name} • Student Developer Portfolio
      </footer>
      <div className="absolute top-0 left-0 w-full h-full z-0 overflow-hidden">
  <div className="absolute w-80 h-80 bg-purple-400 opacity-30 rounded-full filter blur-3xl animate-blob animation-delay-2000"></div>
  <div className="absolute w-72 h-72 bg-pink-500 opacity-30 rounded-full filter blur-2xl top-20 left-1/3 animate-blob animation-delay-4000"></div>
  <div className="absolute w-96 h-96 bg-blue-400 opacity-20 rounded-full filter blur-2xl top-40 left-2/3 animate-blob"></div>
</div>
{/* Blob Background Animation */}
<div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10">
  <div className="absolute bg-purple-500 opacity-30 rounded-full mix-blend-multiply filter blur-3xl w-72 h-72 top-10 left-10 animate-blob"></div>
  <div className="absolute bg-pink-500 opacity-30 rounded-full mix-blend-multiply filter blur-3xl w-72 h-72 top-40 left-48 animate-blob animation-delay-2000"></div>
  <div className="absolute bg-blue-500 opacity-30 rounded-full mix-blend-multiply filter blur-3xl w-72 h-72 top-72 left-20 animate-blob animation-delay-4000"></div>
</div>

    </div>

  );
};

export default StudentDeveloper;
